<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.skillName" clearable placeholder="名称" style="width:180px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="skillName" label="技能名称" min-width="180" show-overflow-tooltip />
      <el-table-column prop="maximumLevel" label="最高等级" width="100" align="center" />
      <el-table-column prop="description" label="说明" min-width="200" show-overflow-tooltip />
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">是</el-tag>
          <el-tag v-else size="mini" type="info">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.skillId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.skillId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.skillId ? '修改技能' : '新增技能'" :visible.sync="visible" width="480px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="名称" prop="skillName"><el-input v-model="form.skillName" /></el-form-item>
        <el-form-item label="最高等级">
          <el-input-number v-model="form.maximumLevel" :min="1" :max="99" style="width:100%" />
        </el-form-item>
        <el-form-item label="说明"><el-input v-model="form.description" type="textarea" :rows="2" /></el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listSkill, getSkill, saveSkill, updateSkill, deleteSkill } from '../../api/skill'

function emptyForm() {
  return { skillId: '', skillName: '', maximumLevel: 5, description: '', active: '1' }
}

export default {
  name: 'MesSkillPage',
  components: { ListPagination },
  data() {
    return {
      query: { skillName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      visible: false,
      saving: false,
      form: emptyForm(),
      rules: {
        skillName: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      }
    }
  },
  created() { this.load() },
  methods: {
    indexMethod(index) { return (this.page - 1) * this.pageSize + index + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listSkill({
        currentPage: this.page,
        pageSize: this.pageSize,
        skillName: this.query.skillName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getSkill(id).then(res => {
        this.form = Object.assign(emptyForm(), res.data || {})
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const req = this.form.skillId ? updateSkill(this.form) : saveSkill(this.form)
        req.then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(id) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteSkill([id]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
